import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "tree-select-value column" }
const _hoisted_2 = { class: "label" }
const _hoisted_3 = {
  key: 1,
  class: "row skeleton"
}

import { random } from 'lodash';
import { computed, onMounted, ref, watch } from 'vue';

import { BaseFieldEmits } from 'SharedComponents/Fields/composables/useBaseFieldProps';
import { ViewFieldProps } from 'SharedComponents/Fields/composables/useViewField';
import SSkeletonItem from 'SharedComponents/ui/SSkeletonItem.vue';
import { CatalogsApi } from 'SharedDir/backend/api';
import { makeRequest } from 'SharedDir/common/composables/useRequests';
import { Catalogs } from 'SharedDir/declarations/catalogs';
import { Field, TreeSelectFieldParams } from 'SharedDir/declarations/fields';
import { NotNull } from 'SharedDir/declarations/shared';
import { MakeDictionary } from 'SharedDir/utils/helpers';

import CatalogSlug = Catalogs.CatalogSlug;


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'TreeSelectValue' },
  __name: 'TreeSelectValue',
  props: {
    modelValue: {},
    label: {},
    showHistory: { type: Boolean },
    history: {},
    field: {}
  },
  emits: ["reveal-history"],
  setup(__props: any, { emit: __emit }) {



const props = __props;
const emits = __emit;

const loading = ref(false);
const requestOptions = {
  startLoading: () => {
    loading.value = true;
  },
  finishLoading: () => {
    loading.value = false;
  },
};
const dict = ref<Record<number, string>>({});

const fetchOptions = async (value: Array<number>) => {
  const slug = props.field.params.catalogSlug;
  if (!slug) return;
  const params = { recordIds: value };
  const { values } = (await makeRequest(
    () => CatalogsApi.ValuesApi(<CatalogSlug>slug).getAllValues(params),
    requestOptions
  )) as { values: Array<Required<NotNull<Catalogs.CatalogsValueFull, 'id'>>> };

  dict.value = MakeDictionary(values, 'id', 'name');
};

const items = computed(() => {
  let value = props.modelValue?.value;
  if (value && !Array.isArray(value)) {
    value = [value];
  }
  if (loading.value) {
    return (value || [null]).map(() => null);
  }

  return (value || []).map((v) => dict.value[v] || `Значение не найдено (${v})`);
});

onMounted(() => {
  fetchOptions(props.modelValue?.value);
});

watch(
  () => props.modelValue,
  (newModelValue) => {
    fetchOptions(newModelValue.value);
  },
  { deep: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("figure", _hoisted_1, [
    _createElementVNode("figcaption", _hoisted_2, _toDisplayString(_ctx.label) + ":", 1),
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
        return (_openBlock(), _createElementBlock("li", { key: index }, [
          (!loading.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(item), 1)
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(SSkeletonItem, {
                  height: 20,
                  class: _normalizeClass(`col-xs-${_unref(random)([4, 11])}`),
                  loading: ""
                }, null, 8, ["class"])
              ]))
        ]))
      }), 128))
    ])
  ]))
}
}

})